import { fmtAgo, fmtDateTime } from "../lib/format";

/**
 * How old is this build?
 *
 * The CEO asked for it while installing R1 — "worth having build time so i can tell how old builds
 * are" — because the page identified builds by sha and application id, and neither is a date.
 *
 * TWO TIMES, NEVER CONFLATED. `built_ts` is when the artifact was cut; `uploaded_ts` is when it was
 * published. The page previously labelled the upload time "built", which is an upload time wearing
 * a build time's name — and the gap between them is exactly what a tester needs when asking "am I
 * running something current?". A build cut on Friday and published on Monday is three days old, not
 * fresh.
 *
 * When the build time is unknown (published before the publisher sent it) we say "published X ago"
 * rather than quietly showing the upload time as a build age. A plausible wrong age is worse than a
 * stated absence on the surface people use to decide whether to reinstall.
 */
export function BuildAge({ builtTs, uploadedTs }: { builtTs?: number | null; uploadedTs: number }) {
  if (builtTs) {
    // Both, when they differ meaningfully — the delay is the informative part.
    const lagMs = uploadedTs - builtTs;
    const published = lagMs > 60 * 60_000 ? `, published ${fmtAgo(uploadedTs)}` : "";
    return (
      <span title={`built ${fmtDateTime(builtTs)} · published ${fmtDateTime(uploadedTs)}`}>
        built {fmtAgo(builtTs)}
        {published}
      </span>
    );
  }
  return (
    <span title={`published ${fmtDateTime(uploadedTs)} · build time not reported by the publisher`}>
      published {fmtAgo(uploadedTs)} <span className="muted">(build time unknown)</span>
    </span>
  );
}
